/**
 * 16b.1 (HataUzunDosya, HataUzunDosyaAyrinti, HataBosCevap): the cards of a turn that ended without an answer, the
 * same words on the web and on the phone. `{{…}}` are filled in by app-core's reply-failure.
 */
export const replyFailureTr = {
  long: {
    title: 'Bu iş tek seferde yazılamayacak kadar uzun.',
    file: 'Oppy {{file}} dosyasının tamamını tek seferde yazmaya çalıştı, ama bir cevapta yazabileceği uzunluğun sınırına takıldı. {{time}} uğraştı, dosyayı bitiremedi.',
    work: 'Oppy işi tek seferde bitirmeye çalıştı, ama bir cevapta yazabileceği uzunluğun sınırına takıldı. {{time}} uğraştı, bitiremedi.',
    workNoTime: 'Oppy işi tek seferde bitirmeye çalıştı, ama bir cevapta yazabileceği uzunluğun sınırına takıldı ve bitiremedi.',
    fileNoTime: 'Oppy {{file}} dosyasının tamamını tek seferde yazmaya çalıştı, ama bir cevapta yazabileceği uzunluğun sınırına takıldı ve dosyayı bitiremedi.',
    unchanged: 'Çalışma alanınızda hiçbir şey değişmedi.',
    changed: 'Bu sırada yazılan dosyalar çalışma alanınızda duruyor.',
    adviceLead: 'Ne yapabilirsiniz:',
    advice: 'İşi parçalara bölün. Önce basit bir sürüm isteyin, sonra adım adım geliştirin.',
  },
  empty: {
    title: 'Oppy bu isteğe cevap veremedi.',
    tries: 'Model {{count}} denemede de boş cevap döndürdü. Bu genelde geçicidir; birkaç saniye sonra yeniden deneyin.',
    once: 'Model boş cevap döndürdü. Bu genelde geçicidir; birkaç saniye sonra yeniden deneyin.',
    advice: 'Sorun sürerse isteği kısaltmayı ya da başka sözcüklerle yazmayı deneyin.',
  },
  actions: {
    simple: 'Basit sürümle başla',
    retry: 'Yeniden dene',
    details: 'Teknik ayrıntılar',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    copyLabel: 'İş numarasını kopyala',
  },
  /** what "Basit sürümle başla" writes into the box (not sent) */
  simplePrompt: 'Önce bunun basit bir sürümünü yap; sonra adım adım geliştirelim.',
  labels: { what: 'Ne oldu', tries: 'Denemeler', timeModel: 'Süre ve model', run: 'İş numarası' },
  what: {
    file: 'Model dosya yazma isteğini yarıda bıraktı; bir cevaptaki uzunluk sınırına ({{limit}} token) ulaşıldı.',
    call: 'Modelin araç çağrısı yarıda kaldı; bir cevaptaki uzunluk sınırına ({{limit}} token) ulaşıldı.',
    thinking: 'Model düşünürken bir cevaptaki uzunluk sınırına ({{limit}} token) ulaştı; yazmaya sıra gelmedi.',
    empty: 'Model görünür bir metin ya da araç çağrısı döndürmedi.',
    unknown: 'Model bir yanıt üretemedi.',
  },
  tries: {
    allCut: '{{count}} deneme, {{all}} de aynı yerde kesildi',
    oneCut: '1 deneme, uzunluk sınırında kesildi',
    someCut: '{{count}} deneme, {{cut}} tanesi uzunluk sınırında kesildi',
    allEmpty: '{{count}} deneme, {{all}} de boş döndü',
    oneEmpty: '1 deneme, boş döndü',
  },
  /** the run chip: "Tamamlanamadı · 4 dk 38 sn · dosya yarıda kaldı" */
  chip: { file: 'dosya yarıda kaldı', limit: 'uzunluk sınırına takıldı' },
  /** the chip's open list when no step finished: one row a try */
  attempt: {
    thinking: '{{n}}. deneme: düşünürken uzunluk sınırına takıldı',
    tool_call: '{{n}}. deneme: yazarken uzunluk sınırına takıldı',
    empty: '{{n}}. deneme: boş döndü',
  },
  /** "üç denemede de" */
  count: { 2: 'iki', 3: 'üç', 4: 'dört', 5: 'beş', 6: 'altı', 7: 'yedi', 8: 'sekiz', 9: 'dokuz', 10: 'on' },
  /** "üçü de" */
  all: { 2: 'ikisi', 3: 'üçü', 4: 'dördü', 5: 'beşi', 6: 'altısı', 7: 'yedisi', 8: 'sekizi', 9: 'dokuzu', 10: 'onu' },
} as const;
